import ISCoachConfigurations from './ISCoachConfigurations';

export default ISCoachConfigurations;
